export type OverlaySize = {width: number; height: number};
export type OverlayPoint = {x: number; y: number};
export type OverlayRect = {left: number; right: number; top: number; bottom: number};
export type PopoverAnchor = OverlayPoint | OverlayRect;
export const POPOVER_MARGIN = 12;

/** Works for coordinates measured from either edge of a container. */
export function clampOverlayCoordinate(value: number, containerSize: number, panelSize: number, margin: number) {
    return Math.min(Math.max(value, margin), Math.max(margin, containerSize - panelSize - margin));
}

export function anchorRect(anchor: PopoverAnchor): OverlayRect {
    return "x" in anchor ? {left: anchor.x, right: anchor.x, top: anchor.y, bottom: anchor.y} : anchor;
}

export function isPopoverOffscreen(anchor: PopoverAnchor, viewport: OverlaySize) {
    const rect = anchorRect(anchor);
    return rect.right < 0 || rect.left > viewport.width || rect.bottom < 0 || rect.top > viewport.height;
}

export function calculatePopoverPosition(anchor: PopoverAnchor, bounds: OverlaySize, panel: OverlaySize,
    gap = 24) {
    const rect = anchorRect(anchor);
    const width = Math.max(0, Math.min(panel.width, bounds.width - 2 * POPOVER_MARGIN));
    const maxHeight = Math.max(0, bounds.height - 2 * POPOVER_MARGIN);
    const height = Math.min(Math.max(0, panel.height), maxHeight);
    const right = rect.right + gap;
    const preferredLeft = right + width <= bounds.width - POPOVER_MARGIN ? right : rect.left - gap - width;
    return {
        left: clampOverlayCoordinate(preferredLeft, bounds.width, width, POPOVER_MARGIN),
        top: clampOverlayCoordinate((rect.top + rect.bottom) / 2 - 24, bounds.height, height, POPOVER_MARGIN),
        width, maxHeight,
    };
}
